import { icons } from "../../../components/html";

export default {
  description: {
    summary: `Provides access for endpoints marked with ${icons.u}. Suitable for user login form single page application. You do not need the API Secure Key to log in. It complies with RFC 6749 4.2`
  }
};
